import { createSchedule, updateSchedule } from "./ScheduleCURD";
import { v4 as uuidv4 } from 'uuid';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { getCurrentDate, getCurrentDateByWeek, getCurrentView } from "../../../util/CalendarUtil";
import { debounce } from "lodash";
import { isClubOwner, isClubStaff, isCoach, isGuest, isUser } from '../../../util/UserRoles'
import { Privileges } from "../../../util/PrivilegeConstants";
import { rootAction } from "../../../redux/reducer/rootReducer";
import { MEMBER_PLAN_REQUIRED_COPY } from "../../../util/calendarAccess";
import { isUpdateEntireSeries, normalizeTeamIds, readFormChecked, readFormValue, readRecurrenceRule, readSchedulerWhoList, recurrenceIdOf, resolveRsvpMaxSlot, seriesIdOf, toScheduleDate, validateSchedulerEditor } from './schedulerForm';


const closeSchedulerEditor = (scheduleRef, onClose) => {
    onClose?.();
    scheduleRef.current?.closeEditor?.();
};

export const saveSchedulerEvent = async (args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig, onClose) => {
    let formData = {};
    const root = args.element;
    const scheduleType = readFormValue(root, '#schedule_type');
    const isRSVP = readFormChecked(root, '#is_rsvp');
    const isAttachGuest = readFormChecked(root, '#is_attach_guest');
    const isAttachAllMember = readFormChecked(root, '#is_attach_all_member');
    const maxSlot = resolveRsvpMaxSlot(isRSVP, readFormValue(root, '#maxSlot'));
    const isEmailDispatch = readFormChecked(root, '#isEmailDispatch');
    const teams = readSchedulerWhoList(root);
    const teamIds = normalizeTeamIds(readFormValue(root, '#PlayerAndTeam') || teams.map((item) => item.id));
    const subject = readFormValue(root, '#title');
    const startTime = toScheduleDate(readFormValue(root, '#StartTime'));
    const endTime = toScheduleDate(readFormValue(root, '#EndTime'));
    const desc = root.querySelector('#Description')?.value ?? '';
    const venue = root.querySelector('#Venue')?.value ?? '';
    const meetingMode = readFormValue(root, '#MeetingMode');
    const platform = readFormValue(root, '#Platform');

    const updateEntireSeries = isUpdateEntireSeries(args.data);

    const error = validateSchedulerEditor(root);
    if (error) {
        return error;
    }

    const resolvedRecurrenceRule = readRecurrenceRule(root, args?.data?.RecurrenceRule || args?.data?.recurrenceRule);

    const debouncedRefresh = debounce(() => {
        setIsRefresh(true);
        if (selectedClub.isPlanRequired) {
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        }
    }, 420);

    const CourtNumber = readFormValue(root, '#CourtNumber') ?? null;
    const eventId = readFormValue(root, '#Event') ?? null;
    const newTeams = teams?.filter((team) => teamIds.some((item) => item === team.id));

    if (scheduleType === 'EVENT') {
        const homeTeamId = readFormValue(root, '#home_team');
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: venue,
            EventId: eventId,
            HomeTeamId: homeTeamId,
            AwayTeamId: null,
            ScheduleType: scheduleType,
            AwayOrgId: null,
            TeamIds: newTeams,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAllDay: false,
            IsAwayOrgRegistered: false,
            AwayTeamName: readFormValue(root, '#AwayTeamNameText'),
            AwayOrganizationName: readFormValue(root, '#AwayOrganizationText'),
            CourtNumber: CourtNumber,
            IsRSVP: isRSVP,
            MaxSlot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachAllMember: isAttachAllMember,
            IsAttachGuest: isAttachGuest,
            IsUpdateEntireSeries: updateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        };
    } else if (scheduleType === 'TEAM_PRACTICE' || scheduleType === 'MEET') {
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: venue,
            EventId: eventId,
            ScheduleType: scheduleType,
            TeamIds: newTeams,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAwayOrgRegistered: false,
            AwayTeamName: null,
            AwayOrganizationName: null,
            CourtNumber: CourtNumber,
            IsRSVP: isRSVP,
            MaxSlot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachAllMember: isAttachAllMember,
            IsAttachGuest: isAttachGuest,
            IsUpdateEntireSeries: updateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        }
    } else {
        formData = {
            Id: args.target.classList.contains('e-appointment') ? args?.data?.Id : uuidv4(),
            Subject: subject,
            StartTime: startTime,
            EndTime: endTime,
            Description: desc,
            Venue: venue,
            ScheduleType: scheduleType,
            TeamIds: newTeams,
            RecurrenceRule: resolvedRecurrenceRule,
            IsAwayOrgRegistered: false,
            AwayTeamName: null,
            AwayOrganizationName: null,
            CourtNumber: CourtNumber,
            MeetingData: {
                mode: meetingMode,
                platform: platform,
            },
            IsRSVP: isRSVP,
            MaxSlot: maxSlot,
            IsEmailDispatch: isEmailDispatch,
            IsAttachGuest: isAttachGuest,
            IsAttachAllMember: isAttachAllMember,
            IsUpdateEntireSeries: updateEntireSeries,
            IsPaid: (selectedClub?.isPlanRequired && calenderConfig?.scheduleCheckout && !isClubOwner(userInfo) && !isClubStaff(userInfo)) ? false : true
        }
    }

    try {
        if (args.target.classList.contains('e-appointment')) {
            formData = { 
                ...formData, 
                RecurrenceID: args.data.RecurrenceID ?? args.data.recurrenceId ?? null,
                recurrenceId: args.data.RecurrenceID ?? args.data.recurrenceId ?? null,
                recurrenceRule: formData.RecurrenceRule
            };
            await updateSchedule(formData, userInfo.userId, selectedClub.clubId);
        } else {
            await createSchedule(formData, userInfo.userId, userInfo.userId, selectedClub.clubId);
        }
        debouncedRefresh();
        closeSchedulerEditor(scheduleRef, onClose);
        return '';
    } catch (error) {
        console.log(error);
        if (!args.target.classList.contains('e-appointment')) {
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        }
        DialogUtility.alert({
            title: 'Alert',
            width: '250px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            content: "something went wrong",
        });
        return 'Unable to save this schedule.';
    }
}

export const onEventClick = (args, scheduleRef, userInfo, calenderConfig, privileges, openSchedulerEditor) => {
    if (args) {
        args.cancel = true;
    }
    if (calenderConfig.scheduleCheckout && args?.event?.IsPaid && !isClubOwner(userInfo)) {
        return;
    }
    if (!privileges?.RESERVATION?.includes(Privileges.MODIFY)) {
        return;
    }
    if (userInfo.userId !== args?.event?.ScheduleCreatedBy && !isClubOwner(userInfo)) {
        return;
    }

    let recurrenceDialog;
    const storedEvents = scheduleRef.current?.eventSettings?.dataSource
        || scheduleRef.current?.eventsData
        || [];
    const storedEvent = storedEvents.find((item) => item?.Id === args.event?.Id);
    const seriesId = seriesIdOf(args.event) || seriesIdOf(storedEvent);
    let eventData = {
        ...args.event,
        SeriesId: seriesId,
        editEntireSeries: false,
        hideRecurrenceEditor: true,
    };
    if (recurrenceIdOf(eventData) || eventData.RecurrenceRule) {
        recurrenceDialog = DialogUtility.confirm({
            title: 'Edit Event',
            content: 'Change this event only, or every event in the series?',
            width: '20vw',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            showCloseIcon: true,
            okButton: {
                text: 'THIS EVENT',
                click: () => {
                    recurrenceDialog.hide();
                    eventData.hideRecurrenceEditor = true;
                    eventData.editEntireSeries = false;
                    openSchedulerEditor?.({ mode: 'Save', data: eventData });
                }
            },
            cancelButton: {
                text: 'ENTIRE SERIES',
                click: () => {
                    recurrenceDialog.hide();
                    eventData.hideRecurrenceEditor = false;
                    eventData.editEntireSeries = true;
                    openSchedulerEditor?.({ mode: 'Save', data: eventData });
                }
            }
        });
    } else {
        openSchedulerEditor?.({ mode: 'Save', data: eventData });
    }
}

export const onSingleClick = (args, scheduleRef, privileges, openSchedulerEditor, blockedBySubscription = false) => {
    if (args) {
        args.cancel = true;
    }
    if (args?.event?.target?.classList.contains("e-more-indicator")) {
        return;
    }
    if (blockedBySubscription) {
        DialogUtility.alert({
            title: 'Subscription required',
            content: MEMBER_PLAN_REQUIRED_COPY,
            width: '300px',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
        });
        return;
    }

    if (!privileges?.RESERVATION?.includes(Privileges.CREATE)) {
        DialogUtility.confirm({
            title: 'Oops!!',
            content: 'You are not authorized to create event',
            width: '20vw',
            position: { X: 'center', Y: 'center' },
            animationSettings: { effect: 'Zoom' },
            showCloseIcon: true,
        });
    } else {
        openSchedulerEditor?.({
            mode: 'Add',
            data: {
                StartTime: args.startTime,
                EndTime: args.endTime,
                IsAllDay: args.isAllDay,
                CourtNumber: args.data?.CourtNumber,
            },
        });
    }
}

export const onPopupOpen = (args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig, privileges) => {
    if (args.type === 'Editor') {
        args.cancel = true;
        return;
    }
    if (args.type === "EventContainer" && args.name === 'popupOpen') {
        args.cancel = false;
        return;
    }

    if (args.type === "QuickInfo" || args.type === "ViewEventInfo") {
        args.cancel = true;
        return;
    }
    if (!privileges?.RESERVATION?.includes(Privileges.MODIFY) && args.data?.Id && !isClubOwner(userInfo)) {
        args.cancel = true;
    }
};

export const onActionComplete = (args, scheduleRef, dispatch) => {
    getCurrentView(scheduleRef, dispatch);
    if (args.requestType !== "viewNavigate" && args.requestType !== "dateNavigate") {
        return;
    }
    const view = scheduleRef.current?.currentView;
    if (view === 'Day' || view === 'TimelineDay') {
        getCurrentDate(scheduleRef, dispatch);
        return;
    }
    getCurrentDateByWeek(scheduleRef, dispatch);
}